import { render, staticRenderFns } from "./Rebounds.vue?vue&type=template&id=6ff0ba4c&name=rebounds&"
import script from "./Rebounds.vue?vue&type=script&lang=js&"
export * from "./Rebounds.vue?vue&type=script&lang=js&"
import style0 from "./Rebounds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports